import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import { BASE_URL } from '../../config/constant';
import useAuth from '../../hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }) => {
  const { isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const isTenantsAdmin =
        userInfo.role_name === 'TenantsAdmin' ||
        userInfo.role_name === 'Client Admin' ||
        userInfo.role_id === 2 ||
        userInfo.role_id === '2';

      const hasNoSubscription =
        userInfo.subscription === false ||
        userInfo.subscription === 'false' ||
        userInfo.subscription === null ||
        userInfo.subscription === undefined;
      
      let isIncomplete = false;
      if (isTenantsAdmin) {
        if (userInfo.isEmailVerified === false) isIncomplete = true;
        if (!userInfo.isPasswordSet || userInfo.isPasswordSet === false || userInfo.isPasswordSet === 'false' || userInfo.isPasswordSet === 0 || userInfo.isPasswordSet === '0') isIncomplete = true;
        if (hasNoSubscription) isIncomplete = true;
      }

      if (isIncomplete) {
        // If the user returns to login while their registration is incomplete,
        // log them out so they are not trapped in a redirect loop.
        logout();
        return;
      }

      navigate(location?.state?.from ? location?.state?.from : BASE_URL, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location, logout]);

  return children;
};

export default GuestGuard;
